import Helmet from 'react-helmet';
import { stringify } from 'qs';
import type { FunctionComponent } from 'react';

import { useLocation, useQuery } from '../../contexts/RouterContext';
import CallToAction from '../CallToAction';
import Subnav from '../generic/Subnav';
import Heading from '../generic/Text/Heading';
import SidebarLayout from '../layouts/SidebarLayout';

import { parseLegalAgentQuery, serializeLegalAgentQuery } from './legalAgentQuery';
import type { LegalAgentQuery } from './legalAgentQuery';
import { LegalAgentScopeSelect } from './LegalAgentScopeSelect';
import { LEGAL_AGENT_ACTIVITY_PATH } from './paths';

/**
 * The Legal Agent portal: header, section subnav, and a left sidebar for scope.
 * Each portal section renders as this route's child.
 */
export const LegalAgentPortal: FunctionComponent = ({ children }) => {
  const { pathname } = useLocation();
  const sectionKey = pathname.replace(/\/+$/, '').split('/').pop() ?? '';
  const [query] = useQuery<LegalAgentQuery, Record<string, unknown>>(parseLegalAgentQuery);
  //  The scope follows the subnav; the actor is Activity-specific and is not carried.
  const activityPath = `${LEGAL_AGENT_ACTIVITY_PATH}${stringify(
    serializeLegalAgentQuery({ ...query, actor: null }),
    { addQueryPrefix: true },
  )}`;

  return (
    <>
      <Helmet title="Legal Agent" />
      <div className="sr-only"><Heading level={1}>Activity</Heading></div>
      <CallToAction noPadding shouldHideBottomBorder />
      <Subnav activeKey={sectionKey}>
        <Subnav.Item to={activityPath} navKey="activity" testId="legal-agent-subnav-activity">
          Activity
        </Subnav.Item>
      </Subnav>
      <div className="container margin-top">
        <SidebarLayout>
          <SidebarLayout.Sidebar>
            <div data-test-id="legal-agent-sidebar"><LegalAgentScopeSelect /></div>
          </SidebarLayout.Sidebar>
          <SidebarLayout.Main>
            {children}
          </SidebarLayout.Main>
        </SidebarLayout>
      </div>
    </>
  );
};
